(() => {
  const desktopQuery = window.matchMedia('(min-width: 750px)');
  const disclosures = [...document.querySelectorAll('.menu-list__disclosure')];

  if (!disclosures.length) return;

  const submenuFor = (button) =>
    button.closest('.menu-list__list-item')?.querySelector(':scope > .menu-list__submenu');

  const setExpanded = (button, expanded) => {
    const submenu = submenuFor(button);
    button.setAttribute('aria-expanded', String(expanded));
    if (submenu) submenu.toggleAttribute('inert', !expanded);
  };

  const closeAll = (except) => {
    disclosures.forEach((button) => {
      if (button !== except) setExpanded(button, false);
    });
  };

  disclosures.forEach((button) => {
    button.addEventListener(
      'click',
      (event) => {
        if (!desktopQuery.matches) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const willOpen = button.getAttribute('aria-expanded') !== 'true';
        closeAll(button);
        setExpanded(button, willOpen);
      },
      true
    );
  });

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      const link = target instanceof Element ? target.closest('.menu-list__submenu a[href]') : null;
      if (
        !link ||
        !desktopQuery.matches ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      /* Horizon can replace or deactivate submenu nodes while the header is
         opening. Delegate from document so every current link still works. */
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(link.href);
    },
    true
  );

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.menu-list__list-item')) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openButton = disclosures.find((button) => button.getAttribute('aria-expanded') === 'true');
    if (!openButton) return;

    closeAll();
    openButton.focus();
  });
})();
